module.exports = require('./null-prune')
